export class RentenInformation {
  regulaererRentenEintritt: Date;
  geplanterRentenEintritt: Date;

  constructor(rentenInformation?: RentenInformation) {
    this.regulaererRentenEintritt = rentenInformation && rentenInformation.regulaererRentenEintritt ? new Date(rentenInformation.regulaererRentenEintritt) : null;
    this.geplanterRentenEintritt = rentenInformation && rentenInformation.geplanterRentenEintritt ? new Date(rentenInformation.geplanterRentenEintritt) : null;
  }
}
